function customVideoPlay(element) {
    var videoId = $(element).find('.custom-autoPlay-videoPlayer').attr('id');
    var btnId = $(element).find('.customVideoPlayButton').attr('id');
    videoPlayOrPause(videoId, btnId);
}

function customVideoPlayMobile(element) {
    var videoId = $(element).find('.custom-autoPlay-videoPlayer-mobile').attr('id');
    var btnId = $(element).find('.customVideoPlayButtonMobile').attr('id');
    videoPlayOrPause(videoId, btnId);
}

function videoPreventClick(e) {
    e.preventDefault();
}

function videoPlayOrPause(id, buttonId) {
    var video = document.getElementById(id);
    var videoButton = $("#" + buttonId);
    if (video.paused) {
        // 暂停状态
        videoButton.fadeOut();
        video.play();
        video.controls = true;
    } else {
        // 播放状态
        videoButton.fadeIn();
        video.pause();
        video.controls = false;
    }
}